var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#141536"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M113.882 26L103.882 36 113.882 46","transform":"translate(-758 -4498) translate(136 4092) translate(519 380) matrix(-1 0 0 1 217.764 0)"}))))));
}

ChevronRight.defaultProps = {"viewBox":"0 0 12 20"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
